import React from 'react';
import {useSelector} from 'Provider';

import HeaderContainer from 'components/HeaderContainer';
import {isLogoExpandedSelector} from 'store/ui';

export interface ConnectedHeaderContainerProps {
  onOpen: (_: boolean) => void;
}

const ConnectedHeaderContainer: React.FC<ConnectedHeaderContainerProps> = ({
  onOpen,
}) => {
  const isLogoExpanded = useSelector(isLogoExpandedSelector);

  return <HeaderContainer expanded={isLogoExpanded} onOpen={onOpen} />;
};

export default ConnectedHeaderContainer;
